<div fxLayout="column" class="tier-planning">
  <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start start">
    <mat-form-field fxFlex>
      <input
        id="tier-name-field"
        type="text"
        matInput
        [(ngModel)]="tierModel.name"
        placeholder="Tier Name"
        [disabled]="!canEdit"
        (ngModelChange)="debounceUpdateTier()"
      />
    </mat-form-field>
    <button *ngIf="canEdit" mat-raised-button color="primary" (click)="addEmptyRow()" [disabled]="tierTemplate">
      Add Exercise
    </button>
    <button id="add-to-lib-btn" mat-stroked-button (click)="addTierToLibrary()">
      <mat-icon>bookmark</mat-icon>
      Add to Library
    </button>
    <button *ngIf="canEdit" mat-raised-button color="warn" (click)="tierDeleted.emit(tier)" [disabled]="tierTemplate">
      Delete Tier
    </button>
    <button mat-icon-button *ngIf="canEdit" (click)="openTrainingLoadDialog()">
      <mat-icon *ngIf="!supportsParameterValidation" color="warn" matTooltip="Training load analysis NOT supported">info</mat-icon>
      <mat-icon *ngIf="supportsParameterValidation" color="primary" matTooltip="Training load analysis supported">check_circle</mat-icon>
    </button>
  </div>
  <div fxLayout="row" fxLayoutGap="16px">
    <div fxLayout="column" fxFlex="80">
      <mat-form-field id="tier-notes-field" floatLabel="never" fxFlex>
        <textarea
          matInput
          [(ngModel)]="tierModel.notes"
          [disabled]="!canEdit"
          (ngModelChange)="debounceUpdateTier()"
          placeholder="Add tier notes"
          rows="6"
        ></textarea>
      </mat-form-field>
    </div>
    <div id="tier-circuit-controls" fxLayout="column">
      <mat-slide-toggle [formControl]="circuitControls.isCircuit" [disabled]="!canEdit">Circuit</mat-slide-toggle>
      <mat-form-field>
        <input
          type="number"
          min="1"
          matInput
          [formControl]="circuitControls.numRounds"
          (keydown)="validateInput($event)"
          placeholder="Number of Rounds" />
      </mat-form-field>
      <mat-form-field>
        <input
          type="number"
          min="1"
          matInput
          [formControl]="circuitControls.restTime"
          (keydown)="validateInput($event)"
          placeholder="Rest Time (in seconds)" />
      </mat-form-field>
    </div>
  </div>
</div>

<div *ngIf="canMoveExercises" class="exercise-planning" cdkDropList (cdkDropListDropped)="dropped($event)">
  <div fxLayout="row" class="exercise-row" fxLayoutAlign="start center" *ngFor="let row of tierModel.rows; let i = index" cdkDrag>
    <mat-icon class="drag-handle" cdkDragHandle [ngClass]="{ 'force-hidden': !canEdit }">drag_handle</mat-icon>
    <mat-icon [ngClass]="{ 'force-hidden': canEdit }">drag_handle</mat-icon>
    <span>{{ getRowLetter(row.order) }}</span>
    <span class="videoIcon" (click)="showVideo(row.exercise_id)">
      <img [src]="getExerciseVideoIcon(row.exercise_id)" />
    </span>
    <mat-form-field fxFlex>
      <input
        [(ngModel)]="row.exercise_name"
        (ngModelChange)="debounceUpdateRow($event, i)"
        (keyup)="filterCategorizedExercises($event.target.value, i)"
        (focus)="filterCategorizedExercises('', i)"
        (blur)="validateExercise($event, i)"
        [disabled]="!canEdit"
        placeholder="Exercise"
        matInput
        [matAutocomplete]="exercisesAuto"
        type="search"
        this.tierModel.rows
        ngDefaultControl
      />
    </mat-form-field>

    <ng-container *ngIf="supportsParameterValidation">
      <mat-form-field fxFlex="10" *ngFor="let param of orderParams(getPossibleParamsForExercise(row))">
        <input
          matInput
          [matTooltip]="getTooltip(row.parameter_selections[param.param], param)"
          [type]="param.type"
          [(ngModel)]="row.parameter_selections[param.param]"
          (ngModelChange)="debounceUpdateTier()"
          (focus)="filterParameterOverrides(i, param.param, '')"
          (keydown)="validateInput($event)"
          (keyup)="filterParameterOverrides(i, param.param, $event.target.value)"
          (blur)="validateParameter($event, i, param.param)"
          [placeholder]="getParameterPlaceholder(param)"
          [disabled]="!canEdit || (circuitControls.isCircuit.value === true && param.param === 'sets')"
          [matAutocomplete]="parametersAuto"
        />
      </mat-form-field>
    </ng-container>

    <ng-container *ngIf="!supportsParameterValidation">
      <mat-form-field fxFlex="10" *ngFor="let param of orderParams(possibleParams)">
        <input
          matInput
          type="text"
          [(ngModel)]="row.parameter_selections[param]"
          (ngModelChange)="debounceUpdateTier()"
          (focus)="filterParameterOverrides(i, param, '')"
          (keyup)="filterParameterOverrides(i, param, $event.target.value)"
          placeholder="{{ param | titlecase }}"
          [disabled]="!canEdit || (circuitControls.isCircuit.value === true && param.param === 'sets')"
          [matAutocomplete]="parametersAuto"
        />
      </mat-form-field>
    </ng-container>

    <span fxFlex="2">
      <mat-icon *ngIf="row.notes" class="clickable" (click)="openNotes(row)" matTooltip="Notes/Regression">speaker_notes </mat-icon>
      <mat-icon *ngIf="!row.notes && canEdit" class="clickable" (click)="openNotes(row)" matTooltip="Notes/Regression">note_add </mat-icon>
    </span>
    <mat-icon *ngIf="canEdit && !tierTemplate" fxFlex="5" (click)="deleteRow(row)" class="clickable">delete</mat-icon>
  </div>

  <mat-autocomplete #exercisesAuto="matAutocomplete" panelWidth="400" [displayWith]="displayFn">
    <mat-option [value]="" class="default-option">---- No Selection ----</mat-option>
    <mat-optgroup *ngFor="let category of filteredCategorizedExercises" [label]="category.category.name">
      <mat-option *ngFor="let exercise of category.exercises" [value]="exercise">
        {{ exercise.name }}
      </mat-option>
    </mat-optgroup>
  </mat-autocomplete>

  <mat-autocomplete #parametersAuto="matAutocomplete" panelWidth="400">
    <mat-option *ngIf="tierTemplate" [value]="''" class="default-option">---- No Selection ----</mat-option>
    <mat-option *ngFor="let parameter of parameterOverrides" [value]="parameter">
      {{ parameter }}
    </mat-option>
  </mat-autocomplete>
</div>

<div *ngIf="!canMoveExercises" class="exercise-planning">
  <div fxLayout="row" class="exercise-row" fxLayoutAlign="start center" *ngFor="let row of tierModel.rows; let i = index">
    <span>{{ getRowLetter(row.order) }}</span>
    <span class="videoIcon" (click)="showVideo(row.exercise_id)">
      <img [src]="getExerciseVideoIcon(row.exercise_id)" />
    </span>
    <mat-form-field fxFlex>
      <input
        [(ngModel)]="row.exercise_name"
        (ngModelChange)="debounceUpdateRow($event, i)"
        (keyup)="filterCategorizedExercises($event.target.value, i)"
        (focus)="filterCategorizedExercises('', i)"
        (blur)="validateExercise($event, i)"
        [disabled]="!canEdit"
        placeholder="Exercise"
        matInput
        [matAutocomplete]="exercisesAuto"
        type="search"
        this.tierModel.rows
        ngDefaultControl
      />
    </mat-form-field>

    <ng-container *ngIf="supportsParameterValidation">
      <mat-form-field fxFlex="10" *ngFor="let param of orderParams(getPossibleParamsForExercise(row))">
        <input
          matInput
          [matTooltip]="getTooltip(row.parameter_selections[param.param], param)"
          [type]="param.type"
          [(ngModel)]="row.parameter_selections[param.param]"
          (ngModelChange)="debounceUpdateTier()"
          (focus)="filterParameterOverrides(i, param.param, '')"
          (keydown)="validateInput($event)"
          (keyup)="filterParameterOverrides(i, param.param, $event.target.value)"
          (blur)="validateParameter($event, i, param.param)"
          [placeholder]="getParameterPlaceholder(param)"
          [disabled]="!canEdit || (circuitControls.isCircuit.value === true && param.param === 'sets')"
          [matAutocomplete]="parametersAuto"
        />
      </mat-form-field>
    </ng-container>

    <ng-container *ngIf="!supportsParameterValidation">
      <mat-form-field fxFlex="10" *ngFor="let param of orderParams(possibleParams)">
        <input
          matInput
          type="text"
          [(ngModel)]="row.parameter_selections[param]"
          (ngModelChange)="debounceUpdateTier()"
          (focus)="filterParameterOverrides(i, param, '')"
          (keyup)="filterParameterOverrides(i, param, $event.target.value)"
          placeholder="{{ param | titlecase }}"
          [disabled]="!canEdit || (circuitControls.isCircuit.value === true && param.param === 'sets')"
          [matAutocomplete]="parametersAuto"
        />
      </mat-form-field>
    </ng-container>

    <span fxFlex="2">
      <mat-icon *ngIf="row.notes" class="clickable" (click)="openNotes(row)" matTooltip="Notes/Regression">speaker_notes </mat-icon>
      <mat-icon *ngIf="!row.notes && canEdit" class="clickable" (click)="openNotes(row)" matTooltip="Notes/Regression">note_add </mat-icon>
    </span>
    <mat-icon *ngIf="canEdit && !tierTemplate" fxFlex="5" (click)="deleteRow(row)" class="clickable">delete</mat-icon>
  </div>

  <mat-autocomplete #exercisesAuto="matAutocomplete" panelWidth="400" [displayWith]="displayFn">
    <mat-option [value]="" class="default-option">---- No Selection ----</mat-option>
    <mat-optgroup *ngFor="let category of filteredCategorizedExercises" [label]="category.category.name">
      <mat-option *ngFor="let exercise of category.exercises" [value]="exercise">
        {{ exercise.name }}
      </mat-option>
    </mat-optgroup>
  </mat-autocomplete>

  <mat-autocomplete #parametersAuto="matAutocomplete" panelWidth="400">
    <mat-option *ngIf="tierTemplate" [value]="''" class="default-option">---- No Selection ----</mat-option>
    <mat-option *ngFor="let parameter of parameterOverrides" [value]="parameter">
      {{ parameter }}
    </mat-option>
  </mat-autocomplete>
</div>

<div fxLayout="row" fxLayoutAlign="end center" *ngIf="tierMetadata">
  <button *ngIf="tierMetadata.tierNumber > 1" mat-button color="primary" (click)="prev()" style="margin-right: 10px;">
    Back
  </button>
  <button
    *ngIf="tierMetadata.tierNumber < tierMetadata.totalTiers"
    mat-raised-button
    color="primary"
    (click)="next()"
    style="margin-right: 10px;"
  >
    Next
  </button>
  <button id="review-workout-btn" mat-raised-button color="primary" *ngIf="tierMetadata.tierNumber === tierMetadata.totalTiers" (click)="complete()">
    Review
  </button>
</div>
